var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-body",attrs:{"id":"my-markdown"}},[_c('vue-markdown',{attrs:{"source":_vm.md}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }